import axios from '@/axios';
import * as api from '../fetch/interface';
import i18n from '@/assets/js/i18n';
import { decrypt } from './api';
import { isWxMiniProgram } from './const';

const insertJs = async function () {
	if (window.TencentCaptcha) {
		return Promise.resolve();
	}

	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';

	document.body.appendChild(script);

	return new Promise(resolve => {
		script.onload = resolve;
	});
};

export const txCaptcha = async function ({ appid }) {
	await insertJs();

	return new Promise((resolve, reject) => {
		try {
			const captcha = new TencentCaptcha(
				appid,
				res => {
					if (res.ret === 0) {
						resolve(res);
					} else {
						reject(res);
					}
					captcha.destroy();
				},
				{
					needFeedBack: false,
					userLanguage: i18n.locale
				}
			);
			captcha.show();
		} catch (e) {
			reject({
				ret: 1
			});
		}
	});
};

export const captchaVerify = async function () {
	if (isWxMiniProgram) {
		return Promise.resolve({ code: 0 });
	}

	const res = await axios.get(api.login.getAuthAppid, {
		verificationScene: 'generic_account'
	});

	if (!res.data.enableAcCaptcha) {
		return { code: 0 };
	}

	return txCaptcha({
		appid: decrypt(res.data.captchaAppId, 'FB1798D4015EE8ED')
	}).then(data => ({
		code: data.ret,
		ticket: data.ticket,
		randstr: data.randstr
	}));
};
